import React, { Component } from 'react';
import styled from 'styled-components';

import LoadingSpinner from '../../../components/LoadingSpinner';

const Overflow = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255,255,255,0.7);
  z-index: 10000;
`;

const SpinnerWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export default class SplashScreen extends Component {

  componentDidMount() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'inherit';
  }

  render() {
    return (
      <Overflow>
        <SpinnerWrapper>
          <LoadingSpinner size="large" />
        </SpinnerWrapper>
      </Overflow>
    );
  }
}




// WEBPACK FOOTER //
// ./src/common/modules/ui/components/SplashScreen.js